import React, { useCallback } from "react";
import { FaWallet } from "react-icons/fa";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useConnect } from "wagmi";

/**
 * Primary "Connect Wallet" CTA on /pay/*.
 *
 * Opens Web3Modal — it owns the branded wallet list, EIP-6963
 * dedupe, recent-wallet memory, and mobile deeplinks. That
 * replaces the raw `connectors.map()` grid which surfaced
 * duplicate Coinbase Wallet entries and a literal "EIP6963"
 * label.
 *
 * Fallback: if Web3Modal isn't available (e.g. the build is
 * running without REACT_APP_PROJECT_ID), connect to the first
 * wagmi connector directly so the page isn't broken. Quiet
 * degradation, not a crash.
 */
export function ConnectWalletCTA() {
  // useWeb3Modal must be called unconditionally (Rules of Hooks).
  // If the provider is missing (no REACT_APP_PROJECT_ID) the hook
  // returns undefined for `open`; we fall back to raw wagmi connect.
  const { open: openModal } = useWeb3Modal();
  const { connect, connectors, isLoading } = useConnect();

  const handleClick = useCallback(() => {
    if (typeof openModal === "function") {
      openModal();
      return;
    }
    const first = connectors?.[0];
    if (first) {
      connect({ connector: first });
    }
  }, [openModal, connect, connectors]);

  return (
    <button
      type="button"
      className="pay-connect-cta"
      onClick={handleClick}
      disabled={isLoading}
    >
      <FaWallet size={16} />
      {isLoading ? "Opening wallet…" : "Connect Wallet"}
    </button>
  );
}
